import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';

import { DashboardConfigurationFilterFormValues } from '../../../../types';

interface FormFooterProps {
  setFilter: (value: Partial<DashboardConfigurationFilterFormValues>) => void;
}

export function FormFooter({ setFilter }: FormFooterProps): React.ReactElement {
  const context = useBaseFormContext<DashboardConfigurationFilterFormValues>();

  function resetFilter() {
    context.setFieldsValue({
      microServiceName: undefined,
      value: undefined,
      hasError: undefined,
    });
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>

      <AntdButton
        type="primary"
        onClick={() => setFilter(context.getFieldsValue())}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}
